import { render, staticRenderFns } from "./KanbanMng.vue?vue&type=template&id=68ec5f9a&scoped=true&"
import script from "./KanbanMng.vue?vue&type=script&lang=js&"
export * from "./KanbanMng.vue?vue&type=script&lang=js&"
import style0 from "./KanbanMng.vue?vue&type=style&index=0&id=68ec5f9a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ec5f9a",
  null
  
)

export default component.exports